import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBooleanGroupUnion"><Path d="M10.5 2C9.11929 2 8 3.11929 8 4.5V8H4.5C3.11929 8 2 9.11929 2 10.5V19.5C2 20.8807 3.11929 22 4.5 22H13.5C14.8807 22 16 20.8807 16 19.5V16H19.5C20.8807 16 22 14.8807 22 13.5V4.5C22 3.11929 20.8807 2 19.5 2H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
